import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const TermWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: ['100%', '100%', '100%', 'repeat(3, 222px) 38px'],
    gridTemplateRows: [
      'repeat(10, 58px)',
      'repeat(10, 58px)',
      'repeat(10, 58px)',
      'repeat(4, 32px)',
    ],
    gridColumnGap: defaultTheme.spacing.xxl,
    gridRowGap: [0, 0, 0, defaultTheme.spacing.s],
    width: '100%',
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
    margin: ['0 auto', '0 auto', 0, 0],
    '& button': {
      width: ['100%', '100%', '100%', '38px'],
      height: ['50px', '50px', '50px', '36px'],
      borderRadius: defaultTheme.border.radius.s,
    },
  }),
);
